import { RouterProvider } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthStore, StaffSession } from '@pa/staff'
import { ExternalNavProvider, type Assign } from '@/features/impersonation'
import { Providers } from './providers'
import type { createAppRouter } from './router'

export function App({
  queryClient,
  router,
  auth,
  session,
  assign,
  clinicOrigin,
}: {
  queryClient: QueryClient
  router: ReturnType<typeof createAppRouter>
  auth: AuthStore
  session: StaffSession
  assign: Assign
  clinicOrigin: string
}) {
  return (
    <Providers queryClient={queryClient} auth={auth} session={session}>
      <ExternalNavProvider assign={assign} clinicOrigin={clinicOrigin}>
        <RouterProvider router={router} />
      </ExternalNavProvider>
    </Providers>
  )
}
